<template>
  <p class="my-address" v-if="object.address">
    <a
      target="_blank"
      :href="'https://www.google.com/maps?q='+object.lat+','+object.lng"
    >
      <i class="fas fa-location-arrow"></i>
      {{'Your address'|translate}} : {{object.address}}
    </a>
  </p>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
export default {
  name: 'CurrentAddressControl',
  components: {

  },
  props: ['object'],
  data () {
    return {
    }
  },
  created () {

    // this.getMyLocation();

  },
  methods: {
    // onAddressChanged(payload) {
    //   if (
    //     payload.response.formatted_address &&
    //     payload.response.geometry &&
    //     payload.response.geometry.location
    //   ) {
    //     this.address = payload.response.formatted_address;
    //     console.log("pay load", payload, payload.response.formatted_address);
    //     let location = payload.response.geometry.location;
    //     this.lat = location.lat();
    //     this.lng = location.lng();
    //     this.emitChange();
    //   }
    // },

    // onAddressCleared() {
    //   this.address = "";
    //   this.lat = null;
    //   this.lng = null;
    //   this.emitChange();
    // },
    // emitChange() {
    //   this.$emit("changeAddress", {
    //     address: this.address,
    //     lat: this.lat,
    //     lng: this.lng,
    //   });
    // },
    getMyLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition)
      }
    },
    showPosition (position) {
      Utils.addressFromLatLng(
        position.coords.latitude,
        position.coords.longitude
      ).then((address) => {
        this.object.lat = position.coords.latitude
        this.object.lng = position.coords.longitude
        this.object.address = address.address
        // this.emitChange();
      })
    }
  },
  mounted () {
    // Vuemit.listen("setAddress", this.onAddressChanged);
    // Vuemit.listen("addressWasCleared", this.onAddressCleared);
  },
  beforeDestroy () {
    // Vuemit.removeAll();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/CurrentAddressControl.vue